document.addEventListener('DOMContentLoaded', function () {
    const qtyInput = document.getElementById('dev_take-mattress-pdp-qty-input');
    const minusBtn = document.querySelector('.mattress-pdp-qty-minus');
    const plusBtn = document.querySelector('.mattress-pdp-qty-plus');
    const addToCartBtns = document.querySelectorAll('.mattress-pdp-form-wrap .mattress-pdp-atc-btn, .sticky-stc-mobile-wrap .mattress-pdp-atc-btn');

    // Check for preserved options from URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    const variantWrapper = document.querySelector(".pv-pdp-variant-wrapper");
    if (!variantWrapper) return;

    const categoryGroupName = "option-category"; // it specifies for radio options
    const mattressGroupName = "option-mattress"; // it specifies select dropdown name
    const colorGroupName = "option-color"; // it specifies radio options

    const categoryInputs = variantWrapper.querySelectorAll(`input[name="${categoryGroupName}"]`);
    const colorInputs = variantWrapper.querySelectorAll(`input[name="${colorGroupName}"]`);

    // mattress is a select dropdown
    const mattressSelect = variantWrapper.querySelector(`select[name="${mattressGroupName}"]`);

    // Function to find matching variant in current product based on option values
    function findMatchingVariant(category, color, mattress) {
        if (!category) return null;

        const variantsToSearch = (window.productVariants || productVariants || window.razorpayDetails?.productVariants);
        if (!variantsToSearch || variantsToSearch.length === 0) return null;

        function variantMatches(v) {
            const opts = [v.option1, v.option2, v.option3];
            if (category && !opts.includes(category)) return false;
            if (color && !opts.includes(color)) return false;
            if (mattress && !opts.includes(mattress)) return false;
            return true;
        }

        return variantsToSearch.find(variantMatches);
    }

    minusBtn?.addEventListener('click', () => {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1);
        qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
    });

    plusBtn?.addEventListener('click', () => {
        qtyInput.value = parseInt(qtyInput.value) + 1;
        qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
    });

    addToCartBtns?.forEach(btn => {
        btn.addEventListener('click', async () => {
            const qty = parseInt(qtyInput?.value || '1');

            const selectedCategory = getSelectedCategory();
            const selectedMattress = getSelectedMattress();
            const selectedColor = getSelectedColor();

            const matchedVariant = findMatchingVariant(selectedCategory, selectedColor, selectedMattress);

            console.log('Adding to cart variant ==> ', matchedVariant);
            if (!matchedVariant) return;

            const variantId = matchedVariant.id;

            try {
                const cartPayload = { id: variantId, quantity: qty };
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify(cartPayload)
                });

                if (!response.ok) throw new Error("Add to cart failed");
                const responseData = await response.json();
                window.dispatchEvent(new CustomEvent('global:addToCart', { detail: { ...responseData, requestedQty: qty ? qty : 1 } }));

                const ajaxCartEl = document.querySelector('#shopify-section-ajaxcart .ajaxcart-content');
                if (ajaxCartEl) {
                    ajaxCartEl.setAttribute('open', '');
                    refreshBundleCart();
                }
            } catch (err) {
                console.error(err);
            }

            document.getElementById('pv-pdp-variant-full-wrapper').style.display = 'none';
            document.body.style.overflow = 'unset';
            document.body.classList.remove('pv-variant-popup-open');
            if(btn.closest('.sticky-stc-mobile-wrap')){
              gaEvent('TSC_atc', ['PDP Bottom Floater', '', '', '', '', ''], false);
            }
        });
    });


    function updatePriceUI(variant) {
        const priceEls = document.querySelectorAll('.dev_update-price-onvariantchange');
        const compareEls = document.querySelectorAll('.dev_update-compareatprice-onvariantchange');
        const discountEls = document.querySelectorAll('.dev_update-discount-onvariantchange');

        const price = (variant.price / 100).toLocaleString('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
        });

        const compareAt = variant.compare_at_price ? (variant.compare_at_price / 100) : null;

        priceEls.forEach(el => {
            el.textContent = price;
        });

        compareEls.forEach(el => {
            if (compareAt && compareAt > variant.price / 100) {
                el.querySelector('span').textContent = `₹${compareAt.toLocaleString('en-IN')}`;
                el.style.display = '';
            } else {
                el.style.display = 'none';
            }
        });

        discountEls.forEach(el => {
            if (compareAt && compareAt > variant.price / 100) {
                const discount = Math.round(((compareAt - variant.price / 100) / compareAt) * 100);
                el.textContent = `${discount}% OFF`;
                el.style.display = '';
            } else {
                el.style.display = 'none';
            }
        });

        if (document.querySelector('.pdp-dynamic-popup')) {
            const popupVariantEls = document.querySelector('.pdp-dynamic-popup .pdp-dc-header-p-varient');
            const popupCompareEls = document.querySelector('.pdp-dynamic-popup .pdp-dc-price-main .pdp-dc-price-value');
            const popupPriceEls = document.querySelector('.pdp-dynamic-popup .pdp-dc-price-discounted .pdp-dc-price-value');
            const popupDiscountEls = document.querySelector('.pdp-dynamic-popup .pdp-dc-price-badge span');

            if (popupVariantEls) popupVariantEls.textContent = variant.title;
            if (popupPriceEls) popupPriceEls.textContent = price;
            if (popupCompareEls) popupCompareEls.textContent = (compareAt && compareAt > variant.price / 100)
                ? `₹${compareAt.toLocaleString('en-IN')}`
                : '';
            if (popupDiscountEls) popupDiscountEls.textContent = (compareAt && compareAt > variant.price / 100)
                ? `${Math.round(((compareAt - variant.price / 100) / compareAt) * 100)}% OFF`
                : '';
        }

    }

    function getSelectedCategory() {
        const checked = variantWrapper.querySelector(`input[name="${categoryGroupName}"]:checked`);
        return checked ? checked.value : null;
    }

    function getSelectedColor() {
        const checked = variantWrapper.querySelector(`input[name="${colorGroupName}"]:checked`);
        return checked ? checked.value : null;
    }

    function getSelectedMattress() {
        if (mattressSelect) return mattressSelect.value || null;
        const checked = variantWrapper.querySelector(`input[name="${mattressGroupName}"]:checked`);
        return checked ? checked.value : null;
    }


    function findSelectedVariant() {
        const selectedCategory = getSelectedCategory();
        const selectedMattress = getSelectedMattress();
        const selectedColor = getSelectedColor();

        // dynamic check across option1/option2/option3
        const variants = (window.productVariants || productVariants || window.razorpayDetails?.productVariants || []);

        const matched = findMatchingVariant(selectedCategory, selectedColor, selectedMattress);

        console.log('variant ==> ', window.productVariants);

        if (matched) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', matched.id);
            window.history.replaceState({}, '', url);
            updatePriceUI(matched);
        } else {
            console.log("No matching variant found");
        }

        const matched_available = variants.find(v => {
            const opts = [v.option1, v.option2, v.option3];
            if (selectedCategory && !opts.includes(selectedCategory)) return false;
            if (selectedColor && !opts.includes(selectedColor)) return false;
            if (selectedMattress && !opts.includes(selectedMattress)) return false;
            return Boolean(v.available);
        });

        const atcWrapper = document.querySelector(".pv-variant-atc-wrapper .mattress-pdp-atc-btn");
        const notifyBtn = document.querySelector("#notify-btn");
        if (matched_available) {
            if (atcWrapper) {atcWrapper.style.display = "block"; atcWrapper.innerText = 'Confirm';}
            if (notifyBtn) notifyBtn.style.display = "none";
            document.querySelectorAll(".out_of_stock, .out_of_stock_card").forEach(el => el.style.display = "none");
            document.querySelectorAll(".mattress-pdp-quantity-wrap .notify-btn, .sticky-stc-mobile-wrap .notify-btn").forEach(el => el.style.display = "none");
            document.querySelectorAll(".mattress-pdp-quantity-wrap .mattress-pdp-atc-btn, .sticky-stc-mobile-wrap .mattress-pdp-atc-btn").forEach(el => el.style.display = "block");
        //     setTimeout(function () {
        //    //  document.querySelector(".custom-pincode-container .estimate-widget").style.display = "block";
        //     }, 2000);
        } else {
            if (atcWrapper) atcWrapper.style.display = "none";
            if (notifyBtn) notifyBtn.style.display = "flex";
            document.querySelectorAll(".out_of_stock, .out_of_stock_card").forEach(el => el.style.display = "block");
            document.querySelectorAll(".mattress-pdp-quantity-wrap .notify-btn, .sticky-stc-mobile-wrap .notify-btn").forEach(el => el.style.display = "flex");
            document.querySelectorAll(".mattress-pdp-quantity-wrap .mattress-pdp-atc-btn, .sticky-stc-mobile-wrap .mattress-pdp-atc-btn").forEach(el => el.style.display = "none");
        //     setTimeout(function () {
        //  //    document.querySelector(".custom-pincode-container .estimate-widget").style.display = "none";
        //     }, 2000);
        }
    }

    // Function to select variant from URL parameter (for marketing campaigns)
    function selectVariantFromURL(variantId) {
        const productVariantsToUse = window.productVariants || productVariants || window.razorpayDetails?.productVariants || [];
        if (!productVariantsToUse || productVariantsToUse.length === 0) return;

        let targetVariant = null;
        if (variantId) {
            targetVariant = productVariantsToUse.find(variant => String(variant.id) === String(variantId));
        }
        if (!targetVariant) {
            targetVariant = productVariantsToUse.find(v => Boolean(v.available)) || productVariantsToUse[0];
        }
        // const targetVariant = productVariantsToUse.find(variant => String(variant.id) === String(variantId));

        if (targetVariant.option1) {
            const categoryInput = variantWrapper.querySelector(`input[name="${categoryGroupName}"][value="${targetVariant.option1}"]`);
            if (categoryInput && !categoryInput.checked) {
                categoryInput.checked = true;
                categoryInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }

        if (targetVariant.option2) {
            const colorInput = variantWrapper.querySelector(`input[name="${colorGroupName}"][value="${targetVariant.option2}"]`);
            if (colorInput && !colorInput.checked) {
                colorInput.checked = true;
                colorInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }

        if (targetVariant.option3 && mattressSelect) {
            const opt = Array.from(mattressSelect.options).find(o => o.value === targetVariant.option3 || o.text === targetVariant.option3);
            if (opt) {
                mattressSelect.value = opt.value;
                mattressSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }

        updatePriceUI(targetVariant);
        findSelectedVariant();
    }

    // listen to mattress select changes
    if (mattressSelect) {
        mattressSelect.addEventListener("change", () => {
            const selected = mattressSelect.value;
            const el = document.getElementById('dev_selected_variant_option2');
            if (el) el.textContent = selected;
            findSelectedVariant();
        });
    }

    // listen to color radio changes
    colorInputs.forEach(input => {
        input.addEventListener("change", () => {
            const selected = input.value;
            const el = document.getElementById('dev_selected_variant_option3');
            if (el) el.textContent = selected;
            findSelectedVariant();
        });
    });

    const urlVariantParam = urlParams.get('variant');
    if (urlVariantParam) {
        setTimeout(() => selectVariantFromURL(urlVariantParam), 500);
    } else {
        setTimeout(() => selectVariantFromURL(null), 500);
    }

    const categoryOptionLabels = document.querySelectorAll('.pv-option-section-category .pv_option_btn');
    categoryOptionLabels.forEach(label => {
        label.addEventListener('click', function () {
            const selectedCategory = this.textContent.trim();
            gaEvent('size_selected', [selectedCategory, '', '', '', '', ''], false);
        });
    });

    const colorOptionLabels = document.querySelectorAll('.pv-option-section-color .pv_option_btn');
    colorOptionLabels.forEach(label => {
        label.addEventListener('click', function () {
            const selectedColor = this.textContent.trim();
            gaEvent('frame_selected', [selectedColor, '', '', '', '', ''], false);
        });
    });

    const mattressOptionLabels = document.querySelector('.pv_section_mattress-wrp .select__select');
    if(mattressOptionLabels != null){
        mattressOptionLabels.addEventListener('change', function () {
            const selectedMattress = mattressOptionLabels.value;
            gaEvent('mattress_selected', [selectedMattress, '', '', '', '', ''], false);
        });
    }

    const bedTypeLabels = document.querySelectorAll('.pv_section_bedtype a');
    if(bedTypeLabels != null){
        bedTypeLabels.forEach(label => {
            label.addEventListener('click', function () {
                const selectedBedType = this.querySelector('label')?.textContent.trim();
                gaEvent('bed_type', [selectedBedType, '', '', '', '', ''], false);
            });
        });
    }

    // const sizeOptionValueLables = document.querySelectorAll('.pv-option-section-size .pv_option_item');
    // sizeOptionValueLables.forEach(label => {
    //     label.addEventListener('click', function () {
    //         const selectedValue = this.querySelector('label')?.textContent.trim();
    //         gaEvent('size_selected', [selectedValue, '', '', '', '', ''], false);
    //     });
    // });

    function validateAdToCart() {
        const variantWrapperElem = document.querySelector('.pv-pdp-variant-wrapper');
        const atcButtons = document.querySelectorAll('#dev_pv_pdp_variant_wrapper .mattress-pdp-atc-btn');

        variantWrapperElem?.classList.remove('pv-variant-atc-disabled');
        atcButtons.forEach(button => {
            button.innerText = 'Confirm';
        });
    }

    categoryInputs.forEach(input => {
        input.addEventListener("change", () => {
            const selected = input.value;
            if (document.getElementById('dev_selected_variant_option1')) document.getElementById('dev_selected_variant_option1').textContent = selected;
            validateAdToCart();
            findSelectedVariant();
        });
    });

    // Bed-type radios: redirect to product URL when selected/clicked
    (function attachBedtypeRedirect() {
        const bedInputs = document.querySelectorAll('.pv_section_bedtype input[name="option-bedtype"]');
        if (!bedInputs || bedInputs.length === 0) return;

        bedInputs.forEach(input => {
            // prefer an enclosing anchor href, fallback to data-href on input/label
            const anchor = input.closest('a');
            const getHref = () => anchor?.getAttribute('href') || input.dataset?.href || null;

            const navigate = () => {
                const href = getHref();
                if (href) window.location.href = href;
            };

            input.addEventListener('change', navigate);

            // ensure label clicks also navigate (some themes stop anchor default)
            const label = document.querySelector(`label[for="${input.id}"]`);
            if (label) {
                label.addEventListener('click', (e) => {
                    e.preventDefault();
                    navigate();
                });
            }

            // keyboard support: enter key on focused input
            input.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    navigate();
                }
            });
        });
    })();

});
//

// The "Learn how to measure" block stays collapsed by default -- it only expands (and starts the
// muted video) on a manual click of the header, and collapses again on a second click or on
// popup close.
(function () {
    var popup = document.getElementById('pv-pdp-variant-full-wrapper');
    var learnWrapper = document.getElementById('dev_pv-variant-learn-how-to');
    var learnTextIcon = document.getElementById('dev_pv-variant-learn-text-icon');
    if (!popup || !learnWrapper) return;

    var video = learnWrapper.querySelector('video');
    var source = video ? video.querySelector('source') : null;

    function collapseAndPause() {
        learnWrapper.classList.remove('pv-video-active');
        if (video) video.pause();
    }

    if (learnTextIcon) {
        learnTextIcon.addEventListener('click', function () {
            if (!video || !source) return;
            gaEvent('Learn_to_measure', ['', '', '', '', '', ''], false);

            var isActive = learnWrapper.classList.toggle('pv-video-active');
            if (isActive) {
                if (!source.getAttribute('src')) {
                    source.setAttribute('src', source.getAttribute('data-src'));
                    video.load();
                }
                var playPromise = video.play();
                if (playPromise && typeof playPromise.catch === 'function') {
                    playPromise.catch(function () {});
                }
            } else {
                video.pause();
            }
        });
    }

    // Collapse + pause when the popup closes, so reopening it doesn't resume mid-video.
    new MutationObserver(function () {
        if (popup.style.display === 'none') collapseAndPause();
    }).observe(popup, {
        attributes: true,
        attributeFilter: ['style']
    });
})();

document.getElementById('dev_pv-variant-popup-close-btn').addEventListener('click', function () {
    document.getElementById('pv-pdp-variant-full-wrapper').style.display = 'none';
    document.body.style.overflow = 'unset';
    document.body.classList.remove('pv-variant-popup-open');
});

document.getElementById('pv-pdp-variant-full-wrapper').addEventListener('click', function (event) {
    const childWrapper = document.getElementById('dev_pv_pdp_variant_wrapper');

    if (!childWrapper.contains(event.target)) {
        document.getElementById('pv-pdp-variant-full-wrapper').style.display = 'none';
        document.body.style.overflow = 'unset';
        document.body.classList.remove('pv-variant-popup-open');
    }
});

const confirmButton = document.querySelector('#pv-pdp-variant-full-wrapper .mattress-pdp-atc-btn');
if (confirmButton) {
    confirmButton.addEventListener("click", function () {
        document.getElementById('pv-pdp-variant-full-wrapper').style.display = 'none';
        document.body.style.overflow = 'unset';
        document.body.classList.remove('pv-variant-popup-open');
        if (window.innerWidth < 991) {
            let optionSelectedLabel = document.querySelector('.mattress-pdp-main-prod .product-size label');
            if (optionSelectedLabel.textContent.includes("Select Size")) {
                optionSelectedLabel.textContent = optionSelectedLabel.textContent.replace("Select Size", "Selected Size");
            }
        }
        var p_type = document.querySelector('body').getAttribute('data-product-type');
        if (p_type === 'Mattresses' || p_type === 'Beds & Bed Frames') {
            gaEvent('size_confirmed', ['', '', '', '', '', ''], false);
        }
    });
}

function handleScroll() {
    const target = document.querySelector('.mattress-pdp-form-wrap');

    if (!target) {
        if (window.scrollY > 240) {
            document.body.classList.add('show-atc-button');
        } else {
            document.body.classList.remove('show-atc-button');
        }
        return;
    }

    const rect = target.getBoundingClientRect();
    if (rect.top <= 0) {
        document.body.classList.add('show-atc-button');
    } else {
        document.body.classList.remove('show-atc-button');
    }
}

window.addEventListener('scroll', handleScroll);
